import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";

export default function useCoreMutations(){
  const { post } = useApiHelper();
  const queryClient = useQueryClient();

  const bulkCompleteStock = useMutation(
    (body: any) => post("/rs/stock/bulk/complete", body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable", "/rs/stock"]);
      }
    }
  );

  const bulkCompleteOrders = useMutation(
    (body: any) => post("/rs/orders/bulk/complete", body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["pagedTable", "/rs/stock"]);
      }
    }
  );

  return {
    bulkCompleteStock,
    bulkCompleteOrders
  }
}